import React, { Component } from 'react'
import FilterActiveIcon from "../../icons/filteractiveicon";
import FilterIcon from "../../icons/filtericon";
import moment from 'moment-timezone'
import ReactPaginate from "react-paginate";
import TextField from '../TextField';

import DatePicker from 'react-datepicker';
import CalendarIcon from '../../icons/calendaricon';
import service from '../../services';
import { data } from 'jquery';
import Loader from '../loader';

let description
let itemsWiseFilterData = [];
let roleWiseFilterData = [];
let screeningTypeFilterData = [];
let sourceFilterData = [];
let sub;

export default class Voting extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fromDate: new Date(),
            toDate: new Date(),
            dateFilterModal: false,
            purchaseReceipt: false,
            dateDisplayFlag: false,
            dateState: false,
            getAllUserActivities: [],
            purchaseList: [],
            searchField: '',
            rolesType: [
                { assign: "sioUser", name: "Industry", value: false },
                { assign: "pressUser", name: "Press", value: false },
                // { assign: "circleUser", name: "Sundance Circle", value: false },
                { assign: 'generalUser', name: 'General', value: false },
                { assign: 'circleGuestUser', name: 'Sundance Guest', value: false },
                { assign: 'artistUser', name: 'Artist', value: false },
            ],
            screeningType: [
                { assign: "1", name: "Premier", value: false },
                { assign: "2", name: "Second Screening", value: false },
                { assign: "3", name: "Award Winner", value: false },
                { assign: '4', name: 'Indies Series', value: false },
                { assign: '5', name: 'Short Program', value: false },
            ],
            // pagination variable diclaration start
            offset: 0,
            perPage: 50,
            currentPage: 0,
            totalPages: 0,
            // pagination variable diclaration end
            activetab: 2,
            userlist: [
                { "label": "Talks & Events" },
                { "label": "Theater Details" },
                { "label": "Online Screenings" },
                { "label": "Voting" },
                { "label": "Product Sales" },
                // { "label": "Reservations" },
                { "label": "Purchases" },
            ]
        }
        this.apiserve = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        roleWiseFilterData = [];
        screeningTypeFilterData = [];
        sourceFilterData = [];
    }

    componentDidMount = async () => {
        const { getLoginAdminByID, getLoginRole } = this.props
        var self = this;
        this.getUserActivities(this.state.offset, this.state.perPage)
        this.setState({
            loaderFlag: true,
        });
        // this.apiserve.sendevent("admin|getUseranalytics", { "tab": 4 });
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "admin|getUseranalytics":
                    if (!response.error) {
                        this.setState({
                            getAllUserActivities: response.data.docs,
                            getTotalDocs: response.data.totalDocs,
                            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                            // totalPages: response.data.totalPages || 0
                        }, () => {
                            this.setState({
                                loaderFlag: false,
                                dateFilterModal: false
                            })
                        })
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
            }
        });
    }


    getUserActivities = (skip, limit) => {
        var data = {}
        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (screeningTypeFilterData.length) {
            data.screenType = screeningTypeFilterData
        }

        data.page = skip
        data.limit = limit
        data.tab = 4
        this.setState({loaderFlag:true})
        this.apiserve.sendevent("admin|getUseranalytics", data);
    }


    clearDateFilter = () => {

        this.setState({ loaderFlag: true, dateDisplayFlag: false, dateState: false })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (screeningTypeFilterData.length) {
            data.screenType = screeningTypeFilterData
        }

        data.page = 1
        data.limit = 50
        data.tab = 4
        this.apiserve.sendevent("admin|getUseranalytics", data);
    }

 //Pagination Click
 handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage + 1;
    this.setState(
        {
            currentPage: selectedPage,
            offset: offset,
            loaderFlag: true
        },
        () => {
            this.getUserActivities(this.state.offset, this.state.perPage, roleWiseFilterData);
        }
    );
};

    //role wise filter
    roleWiseFilter = (e, selectedInex, isClearRoleType = false, isClearItemType) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let roleList = [...this.state.rolesType]
        roleList.forEach((key, i) => {
            if (i === index) {
                roleList[i].value = event
            }
            if (isClearRoleType) {
                roleList[i].value = false
                roleWiseFilterData = []
            }

        })
        this.setState({
            ...this.state,
            rolesType: roleList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    roleWiseFilterData = [...roleWiseFilterData, this.state.rolesType[index].assign];
                }
            } else {
                if (index !== null) {
                    let tempArray = roleWiseFilterData.filter((d) => d !== this.state.rolesType[index].assign);
                    roleWiseFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage, isClearRoleType, isClearItemType);
        })
    };

    //Screening tyep filter
    screeningTypeFilter = (e, selectedInex, isClearRoleType = false, isClearItemType) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let screeningList = [...this.state.screeningType]
        screeningList.forEach((key, i) => {
            if (i === index) {
                screeningList[i].value = event
            }
            if (isClearItemType) {
                screeningList[i].value = false
                screeningTypeFilterData = []
            }

        })
        this.setState({
            ...this.state,
            screeningType: screeningList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    screeningTypeFilterData = [...screeningTypeFilterData, this.state.screeningType[index].assign];
                }
            } else {
                if (index !== null) {
                    let tempArray = screeningTypeFilterData.filter((d) => d !== this.state.screeningType[index].assign);
                    screeningTypeFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage);
        })
    };


    getAllItemFilter = (skip, limit, isClearRoleType, isClearItemType) => {
        this.setState({ loaderFlag: true })
        var data = {
            page: 1,
            limit: 50
        }
        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (screeningTypeFilterData.length) {
            data.screenType = screeningTypeFilterData
        }

        if (this.state.dateState) {
            let fromDate = new Date(this.state.fromDate)
            let toDate = new Date(this.state.toDate)

            fromDate.setHours(0)
            fromDate.setMinutes(0)
            toDate.setHours(23)
            toDate.setMinutes(59)


            data.fromDate = fromDate
            data.toDate = toDate
        }
        data.tab = 4
        this.apiserve.sendevent("admin|getUseranalytics", data);
    }



    render() {
        const { closeModal,roleWiseFilter,rolesType } = this.props
        const { roleWiseFilterData, itemsWiseFilterData, dateStringLabel, getAllUserActivities, screeningType, dateFilterModal, sprofileName } = this.state
        return (
            <>
                <div className="dashboard_data">
                    <table>
                        <thead>
                            <th style={{ width: "222px" }} className="pl_25"><span>Email</span></th>
                            <th style={{ width: "90px" }}><span>First Name</span></th>
                            <th style={{ width: "90px" }}><span>Last Name</span></th>
                            <th style={{ width: "120px" }}>
                                <span className="d_flex d_flex_align_center">
                                    Role
                                    {roleWiseFilterData && roleWiseFilterData.length ?
                                        <FilterActiveIcon />
                                        :
                                        <FilterIcon />
                                    }

                                </span>
                                <div className="tabelData_popup">
                                    <form>
                                        <div className="customCheck">

                                            <>
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => roleWiseFilter(null, null, true, null)}>Clear All</p>
                                                </div>
                                                {rolesType.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            id={item.name}
                                                            name={item.name}
                                                            value={item.value ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => roleWiseFilter(e, i)}
                                                        />
                                                        <label htmlFor={item.name}>
                                                            <span className="check_icon d_flex">
                                                                {item.name}
                                                            </span>
                                                        </label>
                                                    </div>
                                                ))
                                                }
                                            </>
                                        </div>
                                    </form>
                                </div>
                            </th>
                            <th style={{ width: "130px" }}>
                                <span>Film</span>
                            </th>
                            <th style={{ width: "140px" }}>
                                <span className="d_flex d_flex_align_center">
                                    Screening Type
                                </span>
                            </th>
                            <th style={{ width: "110px" }}>Category</th>
                            <th style={{ width: "120px" }}>
                                <span>Screening Date Time (MT)</span>
                            </th>
                            <th style={{ width: "120px" }}>
                                <span>Vote Date Time (MT)</span>
                            </th>
                            <th style={{ width: "80px" }}>
                                <span>In-person or Online</span>
                            </th>
                            <th style={{ width: "80px" }}>
                                <span>Vote</span>
                            </th>
                        </thead>
                        <tbody>
                            {getAllUserActivities.map((getUserActivity, i) => {
                                return (
                                    <tr>
                                        <td style={{ width: "222px" }} className="pl_25">{getUserActivity && getUserActivity.userId && getUserActivity.userData.email}</td>
                                        <td style={{ width: "110px" }}>{getUserActivity && getUserActivity.userId && getUserActivity.userData.fname}</td>
                                        <td style={{ width: "110px" }}>{getUserActivity && getUserActivity.userId && getUserActivity.userData.lname}</td>
                                        <td style={{ width: "120px" }}>{getUserActivity && getUserActivity.userId && getUserActivity.userData.role === 'sioUser' ? 'Industry User' :
                                            getUserActivity && getUserActivity.userId && getUserActivity.userData.role === 'pressUser' ? 'Press User' :
                                                getUserActivity && getUserActivity.userId && getUserActivity.userData.role === 'circleGuestUser' ? 'Sundance Guest' :
                                                    getUserActivity && getUserActivity.userId && getUserActivity.userData.role === 'generalUser' ? 'General User' :
                                                        getUserActivity && getUserActivity.userId && getUserActivity.userData.role === 'artistUser' ? 'Artist User' : '-'}</td>
                                        <td style={{ width: "110px" }}>{getUserActivity && getUserActivity.userId && getUserActivity.filmDetail.title}</td>
                                        <td style={{ width: "110px" }}>
                                            {getUserActivity.filmDetail.dateTime.screeningType === "1" ? 'Premier' :
                                                getUserActivity.filmDetail.dateTime.screeningType === "2" ? 'Second Screening' :
                                                    getUserActivity.filmDetail.dateTime.screeningType === "3" ? 'Award winner' : getUserActivity.filmDetail.dateTime.screeningType === undefined ? 'My Library' : '-'}
                                        </td>
                                        <td style={{ width: "110px" }}>{getUserActivity?.filmDetail?.category?.name}</td>
                                        <td style={{ width: "140px" }}> {moment(getUserActivity?.filmDetail?.dateTime?.date).tz("US/Mountain").format('MM/DD/YYYY')} {moment(getUserActivity.filmDetail?.dateTime?.date).tz("US/Mountain").format('h:mm A')}</td>
                                        <td style={{ width: "140px" }}> {moment(getUserActivity?.voteDate).tz("US/Mountain").format('MM/DD/YYYY')} {moment(getUserActivity?.voteDate).tz("US/Mountain").format('h:mm A')}</td>
                                        <td>
                                            {getUserActivity.filmDetail.dateTime.locationType === "1"
                                                ? "In-Person"
                                                : getUserActivity.filmDetail.dateTime.locationType === "2" || getUserActivity.filmDetail.dateTime.screeningType === undefined
                                                    ? "Online"
                                                    : "-"}</td>

                                        <td style={{ width: "140px" }}> {getUserActivity.vote ? getUserActivity.vote : '0'}/4 </td>
                                        {/* <td style={{ width: "90px" }}> {getUserActivity.orderId}</td>
                                    <td style={{ width: "140px" }}> ${getUserActivity.total} </td> */}
                                        {/* <td style={{ width: "80px" }}> {getUserActivity && getUserActivity.cartData && getUserActivity.cartData.reduce((n, { quantity }) => n + quantity, 0)} </td> */}
                                        {/* <td style={{ width: "110px" }}> {getUserActivity.discountCode ? getUserActivity.discountCode : '-'} </td> */}
                                        {/* <td style={{ width: "110px" }}> {getUserActivity && getUserActivity.userId && getUserActivity.userId.accountBillingAddress && getUserActivity.userId.accountBillingAddress.zipBilling} </td> */}
                                        {/* <td style={{ width: "110px" }}>{ getUserActivity.paymentMethod}</td> */}

                                        {/* <td style={{ width: "170px" }} className="text_center">
                                        <span className="pointer text_center" >
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM7.34844 10.3938L7.35156 10.8891C7.35156 10.9578 7.29531 11.0156 7.22656 11.0156H6.78281C6.71406 11.0156 6.65781 10.9594 6.65781 10.8906V10.4C5.27031 10.2969 4.61719 9.50625 4.54688 8.64688C4.54063 8.57344 4.59844 8.51094 4.67188 8.51094H5.39375C5.45469 8.51094 5.50781 8.55469 5.51719 8.61406C5.59688 9.10938 5.98281 9.47969 6.675 9.57187V7.34219L6.28906 7.24375C5.47188 7.04844 4.69375 6.53906 4.69375 5.48281C4.69375 4.34375 5.55937 3.73125 6.66563 3.62344V3.10781C6.66563 3.03906 6.72188 2.98281 6.79063 2.98281H7.22969C7.29844 2.98281 7.35469 3.03906 7.35469 3.10781V3.61875C8.425 3.72656 9.22812 4.35156 9.32187 5.325C9.32969 5.39844 9.27187 5.4625 9.19687 5.4625H8.49531C8.43281 5.4625 8.37969 5.41563 8.37187 5.35469C8.30937 4.89844 7.94375 4.52656 7.34844 4.44531V6.54375L7.74531 6.63594C8.75781 6.88594 9.44687 7.37031 9.44687 8.45469C9.44687 9.63125 8.57187 10.2875 7.34844 10.3938ZM5.66563 5.41094C5.66563 5.80781 5.91094 6.11562 6.43906 6.30625C6.5125 6.33594 6.58594 6.35938 6.67344 6.38438V4.44688C6.09688 4.52031 5.66563 4.84375 5.66563 5.41094ZM7.48594 7.52344C7.44219 7.51406 7.39844 7.50312 7.34844 7.48906V9.57812C8.01406 9.51875 8.47344 9.15312 8.47344 8.54062C8.47344 8.06094 8.225 7.74844 7.48594 7.52344Z" fill="#5D737E" />
                                            </svg>
                                        </span>
                                    </td> */}
                                    </tr>
                                )
                            })}

                        </tbody>
                    </table>
                </div>
                {/* Pagination View Display */}
                {getAllUserActivities.length && getAllUserActivities ? (
                    <div className="custom-pagination">
                        <ReactPaginate
                            previousLabel={""}
                            nextLabel={""}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={this.state.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.props.handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                            forcePage={this.props.currentPage}
                        />
                    </div>
                ) : (
                    ""
                )}
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                    ""
                )}

                {
                    dateFilterModal ?
                        <div className='user_popup active'>
                            <span className="popup_overlay" onClick={this.props.closeModal}></span>
                            <div className="sundance_popup_detail box_shadow approve_success_popup bg_white overflow_initial" >
                                <div className="approve_popup_header text_center relative pb_0">
                                    <span className="close_popup" onClick={this.props.closeModal}>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.192 0.343994L5.949 4.58599L1.707 0.343994L0.292999 1.75799L4.535 5.99999L0.292999 10.242L1.707 11.656L5.949 7.41399L10.192 11.656L11.606 10.242L7.364 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                                        </svg>
                                    </span>
                                    <h3 className="mb_10">Select Date Filter { }</h3>
                                </div>
                                <div className="content">
                                    <div className="date_content d_flex d_flex_justify_center">

                                        <div className="from_date d_flex d_flex_align_center d_flex_justify_center">
                                            <TextField type="text" name="countDownDate" label="From" disabled={true} value={moment(this.props.fromDate).format(
                                                "MM/DD/YYYY"
                                            )}
                                                placeholder="mm / dd / yyyy" />

                                            <div className=" ml_10 d_flex d_flex_align_center d_flex_justify_center">
                                                <DatePicker
                                                    selected={this.props.fromDate}
                                                    onChange={(e) => this.props.dateChangeForm(e)}
                                                    placeholderText="mm / dd / yyyy"
                                                    maxDate={new Date()}

                                                    customInput={
                                                        <span className="calendar">
                                                            <CalendarIcon opacity="1" />
                                                        </span>
                                                    }

                                                />
                                            </div>
                                        </div>
                                        <div className="to_date d_flex d_flex_justify_center">
                                            <TextField type="text" name="countDownDate" label="To" disabled={true} value={moment(this.props.toDate).format(
                                                "MM/DD/YYYY"

                                            )} placeholder="mm / dd / yyyy" />


                                            <div className=" ml_10 d_flex d_flex_align_center d_flex_justify_center">
                                                <DatePicker
                                                    selected={this.props.toDate}
                                                    onChange={(e) => this.props.dateChangeTo(e)}
                                                    maxDate={new Date()}
                                                    placeholderText="mm / dd / yyyy"
                                                    customInput={
                                                        <span className="calendar">
                                                            <CalendarIcon opacity="1" />
                                                        </span>
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field_row text_center">
                                        <button className="active" onClick={(e) => this.props.dateFilter(this.props.fromDate, this.props.toDate)}>Submit </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        ""
                }
            </>
        )
    }
}

